import React from "react";
import { ExlyInput } from "common/form";
import { StateSelect } from "./StateSelect";
import { INTERNATIONAL_PAYMENT_FIELDS } from "./InternationalPayment.constants";

export const InternationalPaymentFieldsInline = ({
  formValues,
  formMeta,
  onChange,
}) => (
  <div className="tw-flex tw-flex-col">
    {INTERNATIONAL_PAYMENT_FIELDS.map(
      ({ name, label, placeholder, required, isSelect }) => {
        const meta = formMeta?.[name] ?? { touched: false, error: "" };

        return (
          <div
            key={name}
            className="tw-flex tw-items-center tw-gap-4 tw-py-2.5"
          >
            <div className="tw-w-36 tw-shrink-0">
              <span className="tw-text-sm tw-text-[#555]">{label}</span>
              {required && <span className="tw-text-red-500 tw-ml-0.5">*</span>}
            </div>
            <div className="tw-flex-1">
              {isSelect ? (
                <StateSelect
                  value={formValues[name]}
                  onChange={(val) => onChange(val, name)}
                  meta={meta}
                  placeholder={placeholder}
                />
              ) : (
                <ExlyInput
                  placeholder={placeholder}
                  input={{
                    value: formValues[name] ?? "",
                    name,
                    onChange: (e) => onChange(e.target.value, name),
                  }}
                  meta={meta}
                  fullWidth
                />
              )}
            </div>
          </div>
        );
      }
    )}
  </div>
);
